// extracted by mini-css-extract-plugin
export default {"otpInputContainer":"OTPInput_otpInputContainer__2x8-K","otpInput":"OTPInput_otpInput__DJvFq"};